import mixpanel from 'mixpanel-browser';

import {
  setDataToLocalStorage,
  getDataFromLocalStorage,
  setItem,
  getItem,
  clearStorage,
  clearSessionStorage,
  setSessionItem,
  getSessionItem,
} from './storage';
import { authUrls } from '../Urls';

const USER_DETAIL_KEY = 'sl_usr_dl';
export const AUTH_TOKEN_KEY = 'sl_at_to';
const REFRESH_TOKEN_KEY = 'sl_ref_to';

export const setUserDetails = (details) => {
  setDataToLocalStorage(USER_DETAIL_KEY, details);
};

export const getUserDetails = () => getDataFromLocalStorage(USER_DETAIL_KEY);

export const setAuthToken = (token) => {
  setItem(AUTH_TOKEN_KEY, token);
  setSessionItem(AUTH_TOKEN_KEY, token);
};

export const getAuthToken = () => {
  return getItem(AUTH_TOKEN_KEY) ?? getSessionItem(AUTH_TOKEN_KEY);
};

export const setRefreshToken = (token) => setItem(REFRESH_TOKEN_KEY, token);

export const getRefreshToken = () => getItem(REFRESH_TOKEN_KEY);

export const isUserLoggedIn = () => !!getAuthToken();

export const logoutUser = () => {
  try {
    mixpanel.reset();
    window.google.accounts.id.disableAutoSelect();
  } catch (error) {
    console.log(error);
  }
  clearStorage();
  clearSessionStorage();
  window.location = `${authUrls.loginPath}?gs=0`;
};
